/**
 * Angular library starter.
 * Build a library compatible with Angular, AoT compilation & Tree shaking.
 * Written by Roberto Simonetti.
 * MIT license.
 * https://github.com/robisim74/ng2-signalr
 */
/**
 * Entry point for all public APIs of the package.
 */
export { SignalRConnectionMock, SignalRConnectionMockManager, ConnectionStatus, ConnectionStatuses, BroadcastEventListener, SignalRConnection, ConnectionTransport, ConnectionTransports, SignalR, SignalRConfiguration, SignalRModule } from './src/ng2-signalr';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ng2-signalr/index.js
// module id = 569
// module chunks = 0